/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { type } from '../../../shared/utility/utilityHelpers';
import { Action } from '@ngrx/store';

export const ActionTypes = {

  GET_PAYOUT_LIST_ACTION: type('[Payouts] Get Payouts List'),
  GET_PAYOUT_LIST_SUCCESS: type('[Payouts] Get Payouts List success'),
  GET_PAYOUT_LIST_FAIL: type('[Payouts] Get Payouts List Fail'),
};

export class GetPayoutListAction implements Action {
  type = ActionTypes.GET_PAYOUT_LIST_ACTION;
  constructor(public payload: any) {}
}

export class GetPayoutListSuccessAction implements Action {
  type = ActionTypes.GET_PAYOUT_LIST_SUCCESS;
  constructor(public payload: any) {}
}

export class GetPayoutListFailAction implements Action {
  type = ActionTypes.GET_PAYOUT_LIST_FAIL;
  constructor(public payload: any = null) {}
}

export type Actions = | GetPayoutListAction | GetPayoutListSuccessAction | GetPayoutListFailAction;